import { render, staticRenderFns } from "./Salva_body.vue?vue&type=template&id=5a911328"
import script from "./Salva_body.vue?vue&type=script&lang=js"
export * from "./Salva_body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports